import { render, staticRenderFns } from "./UserModules.vue?vue&type=template&id=4e01df12"
import script from "./UserModules.vue?vue&type=script&lang=js"
export * from "./UserModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports